import { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";

import { useNavigate, useParams } from "react-router";

import { Avatar, Box, Button, Card, CardContent, CardHeader, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Grid, Paper, Radio, RadioGroup, Stack, Tab, Tabs, TextField, Typography } from "@mui/material";

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";

import moment from "moment";

import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";
import { TabPanel, TabProps } from "../../../helpers/TabPanel";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout";
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxInformacionAmparo } from "../../../components/BoxInformacionAmparo";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionIrregular } from "../../../components/BoxInformacionIrregular";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";
import { InfoField } from "../../../components/InfoField";

import { Destinatarios } from "./Destinatarios";

import { ActualizarEstatusOficio, GuardarOficio, DetalleOficio } from "../../../connections/tribunal/OficioConnection";

import { defaultDependencia, DependenciaProps } from "../../../interfaces/catalogos/DependenciaInterface";
import { defaultOficio, DestinatarioProps, OficioProps, ActualizarOficioParams } from "../../../interfaces/tribunal/OficioInterface";

DocumentEditorContainerComponent.Inject(Toolbar);

interface ItemModelModif extends ItemModel {
    value?: string;
}

export const AutorizarOficioPage = () => {

    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { Id } = useParams();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const contenidoRef = useRef( '' );

    const dropCampos = useRef<DropDownButton>( null );

    const [value, setValue] = useState( 0 );

    const [oficio, setOficio] = useState<OficioProps>( defaultOficio );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [subtipoAcuerdo, setSubTipoAcuerdo] = useState( 0 );

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );
    const [loadingRegresar, setLoadingRegresar] = useState( false );
    const [loadingGuardar, setLoadingGuardar] = useState( false );

    const [editorReady, setEditorReady] = useState( false );

    const [destinatarios, setDestinatarios] = useState<DestinatarioProps[]>( [] );
    const [dependencia, setDependencia] = useState<DependenciaProps>( defaultDependencia );

    const [autorizar, setAutorizar] = useState( true );
    const [observaciones, setObservaciones] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );
    const [openDialogConfirmacionRegresar, setOpenDialogConfirmacionRegresar] = useState( false );

    let Toolbar: ( CustomToolbarItemModel | ToolbarItem )[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: "e-icons e-drop-down",
        }
    ];

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
            setEditorReady( false );
        }

        setValue( newValue );
    }

    const Guardar = async () => {

        const params: ActualizarOficioParams = {
            idOficio:           Id ?? '',
            idPlantilla:        oficio?.idPlantilla ?? 0,
            contenido:          syncfusionEditor?.current?.documentEditor.serialize() ?? '',
            idSubtipoAcuerdo:   subtipoAcuerdo,
            firmoJuez:          oficio.firmaJuez
        }

        return await GuardarOficio( params );
    }

    const handleGuardar = async () => {

        setLoadingGuardar( true );

        await Guardar().then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch(openSnackbar({ message: message, variant: 'success' }));
                    setLoadingGuardar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch(openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        await ActualizarEstatusOficio({ idOficio: Id ?? '', idEstatus: 45, observaciones: "" }).then(resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                if ( success ) {

                    if ( asignadoMismoUsuario ) {

                        navigate(`/Tribunal/oficio/visualizar/${ Id ?? '' }`);

                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                    }

                    setLoadingFinalizar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleRegresar = async () => {

        setLoadingRegresar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if ( !successGuardar ) {

            setTimeout(() => {

                dispatch(openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingRegresar( false );

            }, 700);

            return;
        }

        await ActualizarEstatusOficio({ idOficio: Id ?? '', idEstatus: 43, observaciones }).then(resp => {

            setTimeout(() => {

                const { success, message, asignadoMismoUsuario, usuarioAsignado } = resp;

                if ( success ) {

                    if ( asignadoMismoUsuario ) {

                        navigate(`/Tribunal/oficio/elaborar/${ Id ?? '' }`);
                    }
                    else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion(`La siguiente actividad se asignó a ${ usuarioAsignado }`);

                    }

                    setLoadingRegresar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingRegresar( false );

                }

            }, 700);

        });

    }

    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( value === 0 && !loading && editorReady && syncfusionEditor.current ) {

            syncfusionEditor.current.documentEditor.open( contenidoRef.current || DefaultDocumentEditor() );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

            dropCampos.current?.appendTo('#dropItem');

        }

    }, [ value, loading, editorReady ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        setLoading(true);

        async function Obtener() {

            await DetalleOficio( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setOficio( resp );

                        contenidoRef.current = resp.contenido;

                        setSubTipoAcuerdo( resp.idSubTipoAcuerdo );
                        setDestinatarios( resp.destinatarios );
                        setDependencia( resp.dependencia ?? defaultDependencia );

                        const mkItem = (text: string, id: string, value: string): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];
                        const joinNames = (arr: string[]) => arr.join(', ');
                        const fmtDate = (d?: Date) => d ? moment(d).format('DD-MM-YYYY') : '';

                        let items: ItemModelModif[] = [
                            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
                            ...mkItem('Numero de Oficio', '2', resp.numeroOficio),
                        ];

                        if ( resp.idExpediente !== 0 ) {
                            const { expediente: e } = resp;
                            const cadenaA = joinNames(e.actores);
                            const cadenaD = joinNames(e.demandados);
                            items.push(
                                ...mkItem('Número de Expediente', '4', e.numeroExpediente),
                                ...mkItem('Tipo de Juicio', '6', e.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', e.juzgadoOrigen),
                                ...mkItem('Fecha del Expediente', '11', fmtDate(e.fecha)),
                                ...mkItem('Actor(es)', '12', cadenaA),
                                ...mkItem('Demandado(s)', '13', cadenaD),
                                ...mkItem('Juez', '13', e.juez),
                            );
                            if ( e.numeroFolio )            items.push(...mkItem('Número de Folio', '14', e.numeroFolio));
                            if ( e.secretarioTramite )      items.push(...mkItem('Secretario de Tramite', '5', e.secretarioTramite));
                            if ( e.secretarioTramiteMenor ) items.push(...mkItem('Secretario de Tramite Menor', '7', e.secretarioTramiteMenor));
                            if ( e.secretarioEjecucion )    items.push(...mkItem('Secretario de Ejecucion', '15', e.secretarioEjecucion));
                        }

                        if ( resp.idExhortoRecibido !== 0 ) {
                            const { exhortoRecibido: ex } = resp;
                            const cadenaA = joinNames(ex.actores);
                            const cadenaD = joinNames(ex.demandados);
                            items.push(
                                ...mkItem('Número de Exhorto', '4', ex.numeroExhorto),
                                ...mkItem('Tipo de Juicio', '6', ex.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', ex.juzgadoOrigen),
                                ...mkItem('Fecha del Exhorto', '11', fmtDate(ex.fecha)),
                                ...mkItem('Actor(es)', '12', cadenaA),
                                ...mkItem('Demandado(s)', '13', cadenaD),
                                ...mkItem('Juez', '13', ex.juez),
                                ...mkItem('Autoridad del Exhorto', '13', ex.autoridadExhortoRecibido),
                            );
                            if ( ex.numeroFolio )             items.push(...mkItem('Número de Folio', '14', ex.numeroFolio));
                            if ( ex.secretario )              items.push(...mkItem('Secretario de Tramite', '5', ex.secretario));
                            if ( ex.numeroExpedienteOrigen )  items.push(...mkItem('Número de Expediente Origen', '7', ex.numeroExpedienteOrigen));
                        }

                        if ( resp.idIrregular !== 0 ) {
                            const { irregular: ir } = resp;
                            const cadenaA = joinNames(ir.actores);
                            const cadenaD = joinNames(ir.demandados);
                            items.push(
                                ...mkItem('Número Irregular', '4', ir.numeroIrregular),
                                ...mkItem('Número de Expediente', '6', ir.numeroExpediente),
                                ...mkItem('Juzgado Origen', '10', ir.juzgadoOrigen),
                                ...mkItem('Fecha del Irregular', '11', fmtDate(ir.fecha)),
                                ...mkItem('Juez', '13', ir.juez),
                            );
                            if ( ir.actores.length > 0 )   items.push(...mkItem('Actor(es)', '12', cadenaA));
                            if ( ir.demandados.length > 0 ) items.push(...mkItem('Demandado(s)', '13', cadenaD));
                            if ( ir.secretario )            items.push(...mkItem('Secretario de Tramite', '5', ir.secretario));
                        }

                        if ( resp.idAmparo !== 0 ) {
                            const { amparo: am } = resp;
                            const cadenaPartes = am.partes
                                .map(p => `${p.persona} (${p.tipoParte})`).join(', ');
                            items.push(
                                ...mkItem('Número de Amparo', '4', am.numeroAmparo),
                                ...mkItem('Juzgado Origen', '10', am.juzgadoOrigen),
                                ...mkItem('Partes del Amparo', '12', cadenaPartes),
                                ...mkItem('Fecha del Amparo', '11', fmtDate(am.fecha)),
                                ...mkItem('Juez', '13', am.juez),
                                ...mkItem('Autoridad del Amparo', '13', am.autoridadAmparo),
                            );
                            if ( am.numeroAmparoOrigen ) items.push(...mkItem('Numero de Amparo Origen', '15', am.numeroAmparoOrigen));
                            if ( am.numeroExpediente )   items.push(...mkItem('Número de Expediente', '6', am.numeroExpediente));
                        }

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                            <span class="e-menu-icon ${data.iconCss}"></span>
                                            <span class="custom-class" >${data.text}</span>
                                        </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText( args?.item.value ?? "" ),
                        },);

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 44 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 44 ) {
                            setLoading( false );
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        if ( Id ) {
            Obtener();
        }

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Oficio' }, { text: 'Autorizar oficio' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ oficio.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label="Oficio" {...TabProps(0)} />
                                        <Tab label="Destinatario(s)" {...TabProps(1)} />

                                        <Tab
                                            label="Información del amparo"
                                            sx={{ display: oficio.idAmparo !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(3)}
                                        />

                                        <Tab
                                            label="Información del expediente"
                                            sx={{ display: oficio.idExpediente !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(4)}
                                        />

                                        <Tab
                                            label="Información del exhorto"
                                            sx={{ display: oficio.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(5)}
                                        />

                                        <Tab
                                            label="Información del irregular"
                                            sx={{ display: oficio.idIrregular !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(6)}
                                        />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion numeroSeguimiento={ `GOF-${oficio.idOficio}` } fecha={ oficio.fecha ?? new Date() } juez={ oficio.juez } numeroOficio={ oficio.numeroOficio } />

                                        <Grid container spacing={ 3 } mt={ 2 }>

                                            {
                                                oficio.plantilla
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Plantilla"
                                                            value={ oficio.plantilla }
                                                        />

                                                    </Grid>
                                            }

                                            {
                                                oficio.idAmparo !== 0
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Tipo de oficio de amparo"
                                                            value={ oficio.subTipoAcuerdo }
                                                        />

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="¿El oficio será firmado por el juez?"
                                                    value={ oficio.firmaJuez ? "Si" : "No" }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <DocumentEditorContainerComponent
                                                    key='DocumentEditorContainer'
                                                    serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                    height='650'
                                                    ref={ syncfusionEditor }
                                                    enableToolbar={ true }
                                                    showPropertiesPane={ false }
                                                    toolbarItems={ Toolbar }
                                                    autoResizeOnVisibilityChange={ false }
                                                    created={ handleEditorCreated }
                                                >
                                                </DocumentEditorContainerComponent>

                                            </Grid>

                                            {
                                                oficio.observaciones.length !== 0
                                                &&
                                                    <Grid size={{ xs: 12, md: 12 }}>

                                                        <Card sx={{ p: 2 }}>

                                                            <Typography variant="h6" sx={{ mb: 2 }}>
                                                                Observaciones
                                                            </Typography>

                                                            <Stack spacing={ 2 }>

                                                                {
                                                                    oficio.observaciones.map( ( { usuario, puesto, observacion, fecha }, i ) => (

                                                                        <Box key={ i } sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>

                                                                            <Avatar
                                                                                sx={{
                                                                                    width: 36,
                                                                                    height: 36,
                                                                                    fontSize: 12,
                                                                                    fontWeight: 500,
                                                                                    bgcolor: (theme) => theme.palette.primary.main,
                                                                                    color: 'white',
                                                                                }}
                                                                            >
                                                                                { usuario.split(" ").slice(0, 2).map(n => n[0]).join("") }
                                                                            </Avatar>

                                                                            <Box
                                                                                sx={{
                                                                                    flex: 1,
                                                                                    bgcolor: "action.hover",
                                                                                    border: "0.5px solid",
                                                                                    borderColor: "divider",
                                                                                    borderRadius: "0 15px 15px 15px",
                                                                                    px: 2,
                                                                                    py: 1.25,
                                                                                }}
                                                                            >
                                                                                <Typography variant="subtitle2" fontWeight={ 500 }>
                                                                                    { usuario } { puesto ? `(${ puesto })` : '' }
                                                                                </Typography>

                                                                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                                                                                    { observacion }
                                                                                </Typography>

                                                                                {
                                                                                    fecha
                                                                                    &&
                                                                                        <Typography variant="caption" color="text.disabled" sx={{ mt: 0.75, display: "block" }}>
                                                                                        {  fecha ? moment( fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                        </Typography>

                                                                                }

                                                                            </Box>

                                                                        </Box>

                                                                    ))
                                                                }

                                                            </Stack>

                                                        </Card>

                                                    </Grid>
                                            }

                                            <Grid size={{ xs: 12, md: 12 }}>

                                                <Card sx={{ p: 1 }}>

                                                    <CardHeader
                                                        title={ <Typography variant="h5">¿Desea autorizar el oficio?</Typography> }
                                                        subheader={
                                                            <FormControl>
                                                                <RadioGroup row>

                                                                    <FormControlLabel
                                                                        label="Si"
                                                                        control={
                                                                            <Radio
                                                                                size="small"
                                                                                checked={ autorizar }
                                                                                onChange={ () => { setAutorizar( true ); setObservaciones( '' ); } }
                                                                            />
                                                                        }
                                                                    />

                                                                    <FormControlLabel
                                                                        label="No"
                                                                        control={
                                                                            <Radio
                                                                                size="small"
                                                                                checked={ !autorizar }
                                                                                onChange={ () => setAutorizar( false ) }
                                                                            />
                                                                        }
                                                                    />

                                                                </RadioGroup>
                                                            </FormControl>
                                                        }
                                                    />

                                                    <Collapse in={ !autorizar }>

                                                        <CardContent>

                                                            <TextField
                                                                fullWidth
                                                                multiline
                                                                rows={ 4 }
                                                                label="Observaciones"
                                                                variant="outlined"
                                                                value={ observaciones }
                                                                onChange={ (e) => setObservaciones(e.target.value) }
                                                                slotProps={{
                                                                    input: { autoComplete: "off" },
                                                                    inputLabel: { shrink: true },
                                                                }}
                                                            />

                                                        </CardContent>

                                                    </Collapse>

                                                </Card>

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            disabled={ autorizar || observaciones === '' }
                                                            onClick={ () => setOpenDialogConfirmacionRegresar( true ) }
                                                        >
                                                            Regresar oficio a elaborar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'center' }}>

                                                        <Button
                                                            fullWidth
                                                            color='secondary'
                                                            variant="outlined"
                                                            loading={ loadingGuardar }
                                                            onClick={ handleGuardar }
                                                        >
                                                            Guardar
                                                        </Button>

                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'right' }}>
                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant="contained"
                                                            disabled={ !autorizar }
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Destinatarios setDependencia={ setDependencia } setDestinatarios={ setDestinatarios } dependencia={ dependencia } destinatarios={ destinatarios } edit={ false } cumplimientoEjecutoria={ oficio.idAmparo !== 0 && oficio.idSubTipoAcuerdo === 17 } />

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <BoxInformacionAmparo
                                        amparo={ oficio.amparo }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 3 }>

                                    <BoxInformacionExpediente
                                        expediente={ oficio.expediente }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 4 }>

                                    <BoxInformacionExhortoRecibido
                                        exhortoRecibido={ oficio.exhortoRecibido }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 5 }>

                                    <BoxInformacionIrregular
                                        irregular={ oficio.irregular }
                                    />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar y firmar el oficio?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar(false) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                    </DialogActions>

                                </Dialog>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionRegresar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea regresar a elaborar el oficio?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingRegresar } onClick={ () => setOpenDialogConfirmacionRegresar(false) }> Cancelar </Button>
                                        <Button loading={ loadingRegresar } onClick={ handleRegresar } variant='contained' > Aceptar </Button>
                                    </DialogActions>

                                </Dialog>
                            </>
            }

        </Layout>
    )
}
